import { render } from "./RecollectAutomationTable.vue?vue&type=template&id=69143ca2"
import script from "./RecollectAutomationTable.vue?vue&type=script&lang=js"
export * from "./RecollectAutomationTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__